import React from 'react';
import {
  Action,
  ActionProps,
  ModalSize,
  Portal,
  useModal,
} from '@doveit/bricks';
import { Agent, IndividualGoal } from '../../../providers/api/dtos';
import SimpleModal from '../../../components/simple-modal/SimpleModal';
import { AgentGoalSimulationView } from '../agent-goal-simulation-view/AgentGoalSimulationView';

export interface SimulateAgentGoalActionProps extends Pick<ActionProps, 'size' | 'disabled' | 'color' | 'emphasis'> {
  agentId: NonNullable<Agent['id']>,
  label?: string,
  onSuccess?: (individualGoal: IndividualGoal) => void,
  children?: ({ disabled, simulate }: { disabled?: boolean, simulate: VoidFunction }) => React.ReactNode
}

export const SimulateAgentGoalAction: React.FC<SimulateAgentGoalActionProps> = ({
  agentId,
  onSuccess,
  disabled,
  children,
  label,
  ...rest
}) => {
  const simulateGoalModal = useModal();

  const onGoalAccepted = React.useCallback((goal: IndividualGoal) => {
    onSuccess?.(goal);
    simulateGoalModal.close();
  }, [onSuccess, simulateGoalModal]);

  return (
    <>
      {children
        ? children({ disabled, simulate: simulateGoalModal.open })
        : (
          <Action
            {...rest}
            label={label || 'Simula obiettivo'}
            onClick={() => simulateGoalModal.open()}
            aria-label={'Pulsante per simulare l\'obiettivo di guadagno agente'}
          />
        )}
      <Portal>
        <SimpleModal
          {...simulateGoalModal}
          title="Simula obiettivo di guadagno"
          size={ModalSize.XLARGE}
          aria-label={'Modale per simulare l\'obiettivo di guadagno agente'}
        >
          <AgentGoalSimulationView
            agentId={agentId}
            onGoalAccepted={onGoalAccepted}
          />
        </SimpleModal>
      </Portal>
    </>
  );
};
